import Base16 from "./base16"
/**
 * 时间格式化
 * @param timestamp
 * @returns {string}
 */
export const timeFormat = timestamp => {
  let time, Y, M, D, h, m, s
  time = new Date()
  time.setTime(timestamp)
  Y = time.getFullYear()
  M = time.getMonth() + 1
  D = time.getDate()
  h = time.getHours()
  m = time.getMinutes()
  s = time.getSeconds()
  return (
    Y +
    "-" +
    (M < 10 ? "0" + M : M) +
    "-" +
    (D < 10 ? "0" + D : D) +
    " " +
    (h < 10 ? "0" + h : h) +
    ":" +
    (m < 10 ? "0" + m : m) +
    ":" +
    (s < 10 ? "0" + s : s)
  )
}
// 手机号校验规则
export const validatePhone = (rule, value, callback) => {
  //校验手机号，1开头11位为手机号验证
  let pattern = /^1[0-9]{10}$/
  value = "" + value
  if (value.length === 0) {
    callback()
  } else {
    if (!pattern.test(value)) {
      callback([new Error("请输入格式正确的手机号码")])
    } else {
      callback()
    }
  }
}
// url校验
export const validateUrl = (rule, value, callback) => {
  //校验以http://、https://开头的url
  let pattern = /(http|https):\/\/([\w.]+\/?)\S*/
  value = "" + value
  if (!pattern.test(value)) {
    callback([new Error("URL格式不正确")])
  } else {
    callback()
  }
}
// url校验
export const validateRedirectUrl = (rule, value, callback) => {
  //校验以http://、https://开头的url
  let pattern = /(http|https):\/\/([\w.]+\/?)\S*/
  let valueArr = ("" + value).split("\n").filter(item => item !== "")
  if (valueArr.find(item => !pattern.test(item))) {
    callback([new Error("URL格式不正确")])
  } else {
    callback()
  }
}
/**
 * randomWord 产生任意长度随机字母数字组合
 * @param randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * @param min
 * @param max
 * @returns {string}
 * 调用方法:
 * 生成 3 - 32 位随即字符串
 * randomWord(true,3,32);    例如：olyOXUF5oDsuMmXl3Mi48
 * 生成 32 位随机字符串
 * randomWord(false,32);     例如：fjpnWj29Bb8boiXbLeDF0nxkR4aYcLRl
 */
export const randomWord = (randomFlag, min, max) => {
  let str = ""
  let range = min
  let arr = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ]
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
/**
 * 存储localStorage，用base16加密后存储
 */
export const setStore = (name, content) => {
  if (!name) return
  content = JSON.stringify(content)
  window.localStorage.setItem(name, Base16.Encode(content))
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  if (window.localStorage.getItem(name)) {
    return JSON.parse(Base16.Decode(window.localStorage.getItem(name)))
  }
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 根据指定的对象字段名，扁平化对象数组
 * arr：对象数组
 * field：需要扁平化的对象字段名
 */
export const flatten = (arr, field) => {
  return arr.reduce((pre, cur) => {
    pre = pre.concat(cur)
    return Array.isArray(cur[field]) && cur[field].length !== 0
      ? pre.concat(flatten(cur[field], field))
      : pre
  }, [])
}
